import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('refosumu-shared-company-reform-areas', class extends Controller {
  static targets = ['container', 'toggleText', 'toggleIcon']

  toggle() {
    const isExpanded = this.containerTarget.classList.contains('is-expanded')

    if (isExpanded) {
      // 閉じる
      this.containerTarget.classList.remove('is-expanded')
      this.toggleTextTarget.textContent = 'もっと見る'
      this.toggleIconTarget.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 2V14M2 8H14" stroke="#0088FF" stroke-width="2" stroke-linecap="round"/></svg>'
    } else {
      // 開く
      this.containerTarget.classList.add('is-expanded')
      this.toggleTextTarget.textContent = '閉じる'
      this.toggleIconTarget.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 8H14" stroke="#0088FF" stroke-width="2" stroke-linecap="round"/></svg>'
    }
  }
})
